import authenticationService from "./AuthenticationService";
import { apiRequest } from "./APIService";
import { isAlphanumericOrderId } from "../util/utils";

class ExamsService {
  constructor() {
    this.runningFunctionsReference = {};
    if (!ExamsService._instance) {
      ExamsService._instance = this;
    }
    return ExamsService._instance;
  }

  async getTypes() {
    try {
      let request = {};

      request =
        authenticationService.setUserAuthorizationDataOnRequest(request);

      let response = await apiRequest("POST", "/ListarTipoExame", request);

      if (response && response.exams) {
        let examsTypes = response.exams;

        return examsTypes.map(
          (item) => `${item.exam} : ${item.examDescription}`
        );
      } else {
        return null;
      }
    } catch (error) {
      console.error(`Error when trying to get exam types: ${error.message}`);
      return null;
    }
  }

  async get({ orderBy, filterBy, limit = 20, page = 1, lastId = null }) {
    try {
      let request = {
        orderBy,
        filterBy,
        page,
        limit,
        lastId,
      };

      let orderIdIndex = this.getExamFilterIndex(filterBy, "OrderId");
        
      if (
        orderIdIndex !== -1 &&
        orderIdIndex !== null &&
        orderIdIndex !== undefined &&
        isAlphanumericOrderId(filterBy[orderIdIndex].OrderId)
      ) {
        let orderId = await this.getOrderIdFromAlphanumericCode(
          filterBy[orderIdIndex].OrderId
        );

        orderId && (filterBy[orderIdIndex].OrderId = orderId);
      }

      request =
        authenticationService.setUserAuthorizationDataOnRequest(request);

      let response = await apiRequest("POST", "/ConsultarExame", request);

      if (response && response.exams) {
        let exams = response;

        if (response.AggregatedData) {
          let statistics = this.buildStatus(response.AggregatedData);
          delete response.AggregatedData;
          response.statistics = statistics;
        }

        return exams;
      } else {
        return [];
      }
    } catch (error) {
      console.error(`Error when trying to get exams: ${error.message}`);
      return null;
    }
  }

  async getHistory({ examId, orderId }) {
    try {
      if (examId && orderId) {
        let request = { examId, orderId };

        request =
          authenticationService.setUserAuthorizationDataOnRequest(request);

        let response = await apiRequest(
          "POST",
          "/ListarHistoricoExame",
          request
        );

        if (response && response.events) {
          let examEvents = response.events;

          examEvents = this.removeHistoryDuplicatedStatus(examEvents);

          return examEvents;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (error) {
      console.error(`Error when trying to get exam history: ${error.message}`);
      return null;
    }
  }

  async getStatus() {
    try {
      let request = {};

      request =
        authenticationService.setUserAuthorizationDataOnRequest(request);

      let response = await apiRequest("POST", "/SituacaoExameCliente", request);

      if (response && response.data) {
        let examsStatus = response.data;

        let buildedExamsStatus = this.buildStatus(examsStatus);

        return buildedExamsStatus;
      } else {
        return null;
      }
    } catch (error) {
      console.error(`Error when trying to get exam status: ${error.message}`);
      return null;
    }
  }

  async getResult(orderId, examId, year){
    try {
      let request = {};

      if(orderId && examId && year){
        request = {orderId,examId, year};

        request =
        authenticationService.setUserAuthorizationDataOnRequest(request);

        let response = await apiRequest("POST", "/GetResultadoExamePedido", request, {
          responseType: 'arraybuffer',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
          }
        });

        if (response){ 
          return response;
        } else {
          return null;
        }
      }
    
    } catch (error) {
      console.error(`Error when trying to get the result: ${error.message}`);
      return null;
    }

  }

  async startGettingDataFrom(
    functionName = "",
    parameters = {},
    callback = () => {},
    every = 10000
  ) {
    let recurrentReference = setInterval(async () => {
      let result = await this[functionName]({ ...parameters });
      callback(result);
    }, every);

    if (!this.runningFunctionsReference[functionName]) {
      this.runningFunctionsReference[functionName] = {};
    }

    this.runningFunctionsReference[functionName][recurrentReference] =
      recurrentReference;

    let result = await this[functionName]({ ...parameters });

    if(
      this.runningFunctionsReference && 
      this.runningFunctionsReference[functionName] &&
      this.runningFunctionsReference[functionName][recurrentReference]
    ){
      callback(result);
    }

    return recurrentReference;
  }

  stopGettingDataFrom(functionName, functionReference) {
    if (functionName && !functionReference) {
      if (
        this.runningFunctionsReference[functionName] &&
        Object.keys(
          this.runningFunctionsReference[functionName]
        ).length > 0
      ) {
        let functionReferences = Object.keys(
          this.runningFunctionsReference[functionName]
        );

        for (const referenceIndex of functionReferences) {
          clearInterval(
            this.runningFunctionsReference[functionName][referenceIndex]
          );
          delete this.runningFunctionsReference[functionName][referenceIndex];
        }
      }
    }

    if (functionName && functionReference) {
      if (
        this.runningFunctionsReference[functionName] &&
        this.runningFunctionsReference[functionName][functionReference]
      ) {
        clearInterval(
          this.runningFunctionsReference[functionName][functionReference]
        );
        delete this.runningFunctionsReference[functionName][functionReference];
      }
    }
    return true;
  }

  stopGettingAllData() {
    if (
      this.runningFunctionsReference &&
      Object.keys(this.runningFunctionsReference).length > 0
    ) {
      for (const functionReference in this.runningFunctionsReference) {
        let functionReferences = Object.keys(
          this.runningFunctionsReference[functionReference]
        );

          if(functionReferences && functionReferences.length>0){
            for (const functionIndex of functionReferences) {
              clearInterval(
                this.runningFunctionsReference[functionReference][functionIndex]
              );
              delete this.runningFunctionsReference[functionReference][functionIndex];
            }
          }
      }
    }

    return true;
  }

  buildStatus(examsStatus) {
    let buildedExamsStatus = {};

    for (const status of examsStatus) {
      if (status && status.prodUnit) {
        if (!buildedExamsStatus[status.prodUnit]) {
          buildedExamsStatus[status.prodUnit] = {};
          buildedExamsStatus[status.prodUnit]["TOTAL"] = 0;
          buildedExamsStatus[status.prodUnit]["aliasProdUnit"] = status.aliasProdUnit;
        }
        if (!buildedExamsStatus["BR"]) {
          buildedExamsStatus["BR"] = {};
          buildedExamsStatus["BR"]["TOTAL"] = 0;
        }
        if (
          buildedExamsStatus["BR"] &&
          !buildedExamsStatus["BR"][status.descEventStage]
        ) {
          buildedExamsStatus["BR"][status.descEventStage] = 0;
        }

        if(status.clientState){
          buildedExamsStatus["BR"]["clientState"]= status.clientState;
        }
      
        buildedExamsStatus["BR"][status.descEventStage] += status.qtyEventStage;
        buildedExamsStatus[status.prodUnit][status.descEventStage] =
          status.qtyEventStage;

          
        buildedExamsStatus["BR"]["TOTAL"] += status.qtyEventStage;
        buildedExamsStatus[status.prodUnit]["TOTAL"] += status.qtyEventStage;

        if(status.descEventStage === "CADASTRADO" || status.descEventStage === "RECOLHIDO"){
          buildedExamsStatus[status.prodUnit][`${status.descEventStage}-LOCATION`] = {};
          let eventLocation = buildedExamsStatus[status.prodUnit][`${status.descEventStage}-LOCATION`];

          if(status.codePardiniStore){
            eventLocation["codePardiniStore"]= status.codePardiniStore;
          }
          if(status.namePardiniStore){
            eventLocation["namePardiniStore"]= status.namePardiniStore;
          }
          if(status.stateStore){
            eventLocation["stateStore"]= status.stateStore;
          }
          if(status.clientState){
            eventLocation["clientState"]= status.clientState;
          }
          if(status.homeState){
            eventLocation["homeState"]= status.homeState;
          }
        }
      }
    }

    return buildedExamsStatus;
  }

  removeHistoryDuplicatedStatus(statusHistory) {
    let haveHistory = [];
    let newHistory = [];

    if (statusHistory) {
      for (const status of statusHistory) {
        if (status.stageName && haveHistory.indexOf(status.stageName) === -1) {
          haveHistory.push(status.stageName);
          newHistory.push(status);
        }
      }
    }
    return newHistory;
  }

  async getOrderIdFromAlphanumericCode(alphanumeric){

    if(alphanumeric!==null && alphanumeric!==undefined){

      let request = {orderIdAlphaNumeric: alphanumeric.toUpperCase()};

      request = authenticationService.setUserAuthorizationDataOnRequest(request);

      let response = await apiRequest("POST", "/ConverterBase36ToDecimal", request);

      if (
        response &&
        response.base36ToDecimal &&
        response.base36ToDecimal.length &&
        response.base36ToDecimal[0].orderId &&
        response.base36ToDecimal[0].orderId !== ""
      ) {
        return response.base36ToDecimal[0].orderId ;
      } else {
        return null;
      }
    }
  }

  getExamFilterIndex(filters, filterName){
    if(filters && filters.length && filters.length > 0 && filterName){
      return filters.findIndex((filter)=> filter[filterName]);
    } else {
      return null;
    }
  }

  static getInstance() {
    return this._instance;
  }
}

export default new ExamsService();
